module.exports = __webpack_public_path__ + "static/img/industrial-fluid-buffer_256.5af0e9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industrial-fluid-buffer_256.png
// module id = N1MF
// module chunks = 0